import { FormApi } from "final-form";
import { useForm } from "react-final-form";
import useDebounce from "src/ui/hooks/useDebounce";

import { showErrorToast } from "@shared/toasts/Toasts";
import { IDetectedBarcode, Scanner } from "@yudiel/react-qr-scanner";

import { FormValues } from "./AddDeviceModal";
import { parseQrCodeValue } from "./AddDeviceModal.utils";

const waitForValidation = (form: FormApi<FormValues>, maxAttempts = 60000) => {
    return new Promise<void>((resolve) => {
        let attempts = 0;
        const checkValidation = () => {
            const state = form.getState();
            if (!state.validating || attempts >= maxAttempts) {
                resolve();
            } else {
                attempts++;
                setTimeout(checkValidation, 10);
            }
        };
        checkValidation();
    });
};

export const QrScanner = () => {
    const form = useForm<FormValues>();

    const onError = (error: unknown) => {
        const err = error as Error;
        showErrorToast(err.message);
    };
    const onScan = useDebounce(
        async (detectedCodes: IDetectedBarcode[]) => {
            const rawValue = detectedCodes[0]?.rawValue;
            if (rawValue) {
                const serialValue = parseQrCodeValue(rawValue);
                form.change("androidSerial", serialValue);
                form.blur("androidSerial");
                await waitForValidation(form);
                await form.submit();
            }
        },
        1000,
        { leading: true, trailing: false },
    );

    return (
        <Scanner
            styles={{ video: { width: "100%", height: 340 }, container: { width: "100%", height: 340 } }}
            onScan={onScan}
            onError={onError}
            allowMultiple={false}
        />
    );
};
